/**
 * Pipes a value through a series of functions.
 * Each function can only accept a single value and must return a value.
 */
module.exports = function pipe() {
  var args = [].slice.call(arguments)
  return function (value) {
    return args.reduce(function (input, fn) {
      return fn(input)
    }, value)
  }
}
